module.exports = __webpack_public_path__ + "static/media/16UNODC4.e27db033.jpg";